export default __webpack_public_path__ + "static/media/error.f97aca6f.png";